<div
  id="entities"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      fxLayout="row"
      fxLayoutAlign="center center"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      <button mat-icon-button (click)="return()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      {{ entityData.displayName }}
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content-card" fxFill>
    @if (isBusy) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
        class="mat-progress-bar">
      </mat-progress-bar>
    }
    <div class="content">
      <div class="content" fxLayout="row wrap">
        <div
          fxLayout="column"
          fxFlex="30"
          fxFlex.md="30"
          fxLayout="column"
          class="card-profile-container">
          <mat-card class="mat-card profile-card">
            <h2 class="card-title">
              {{ 'SINGLE-TEAM.BASIC-INFORMATION' | translate }}
            </h2>
            @if (!isBusy) {
              <div class="profile-picture" fxLayoutAlign="center center">
                <img
                  class="profile-image"
                  [src]="imageUrl()"
                  [@animate]="{
                    value: '*',
                    params: { delay: '50ms', scale: '1' },
                  }"
                  alt="Avatar du profil" />
              </div>
              <div fxLayoutAlign="center center" class="profile-name"></div>
              <mat-list role="list" class="entity-info-list">
                <mat-list-item class="displayName">
                  <div matListItemTitle>{{ entityData.displayName }}</div>
                </mat-list-item>
                @if (entityData.description) {
                  <mat-list-item>
                    <mat-icon matListItemIcon>description</mat-icon>
                    <h4 matListItemTitle class="nobreak">
                      {{ entityData.description }}
                    </h4>
                  </mat-list-item>
                }
                @if (entityData.mail) {
                  <mat-list-item>
                    <mat-icon matListItemIcon>alternate_email</mat-icon>
                    <h4 matListItemTitle class="nobreak">
                      {{ entityData.mail }}
                    </h4>
                  </mat-list-item>
                }
                @if (
                  entityData.isArchived !== null &&
                  entityData.isArchived !== undefined
                ) {
                  <mat-list-item>
                    <mat-icon matListItemIcon>inventory_2</mat-icon>
                    @if (entityData.isArchived) {
                      <h4 matListItemTitle>
                        {{ 'TEAMS-PAGE.ARCHIVED' | translate }}
                      </h4>
                    } @else {
                      <h4 matListItemTitle>
                        {{ 'TEAMS-PAGE.ONLINE' | translate }}
                      </h4>
                    }
                  </mat-list-item>
                }
              </mat-list>
            }
            @if (isBusy) {
              <div
                class="general-container"
                fxLayout="row"
                fxLayoutAlign="center center">
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              </div>
            }
          </mat-card>
        </div>
        <div fxLayout="column" class="users-tables">
          <app-users-table
            [title]="translationEntityOwners"
            [entityId]="entityId"
            [usersType]="'owners'" />
          <app-users-table
            [title]="translationEntityMembers"
            [entityId]="entityId"
            [usersType]="'members'" />
        </div>
      </div>
    </div>
  </div>
</div>
